import { useShowContextRequired } from "ui-builder";
import { ProjectDetailsField } from "nekst-api";
import { NewLineBadgeLayout } from "./NewLineBadgeLayout";
import { TextBadge, TextBadgeVariant } from "features/nekst-widgets";
import React from "react";

export default function IsClosingDateField() {
  const showContext = useShowContextRequired<ProjectDetailsField>();

  if (showContext.data.isClosingDateField) {
    return (
      <NewLineBadgeLayout>
        <TextBadge
          variant={TextBadgeVariant.PRIMARY}
          text="Closing Date"
          isSmall
          title="Used to track when transactions close and calculate commission statistics by time period"
        />
      </NewLineBadgeLayout>
    );
  } else {
    return null;
  }
}
